import { g as v } from "./_commonjsHelpers-DaMA6jEr.mjs";
var x = { exports: {} };
/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
(function(l, h) {
  (function(p) {
    var d;
    if (l.exports = p(), d = !0, !d) {
      var a = window.Cookies, r = window.Cookies = p();
      r.noConflict = function() {
        return window.Cookies = a, r;
      };
    }
  })(function() {
    function p() {
      for (var r = 0, o = {}; r < arguments.length; r++) {
        var s = arguments[r];
        for (var u in s)
          o[u] = s[u];
      }
      return o;
    }
    function d(r) {
      return r.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function a(r) {
      function o() {
      }
      function s(n, i, e) {
        if (!(typeof document > "u")) {
          e = p({
            path: "/"
          }, o.defaults, e), typeof e.expires == "number" && (e.expires = new Date(/* @__PURE__ */ new Date() * 1 + e.expires * 864e5)), e.expires = e.expires ? e.expires.toUTCString() : "";
          try {
            var g = JSON.stringify(i);
            /^[\{\[]/.test(g) && (i = g);
          } catch {
          }
          i = r.write ? r.write(i, n) : encodeURIComponent(String(i)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), n = encodeURIComponent(String(n)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
          var f = "";
          for (var c in e)
            e[c] && (f += "; " + c, e[c] !== !0 && (f += "=" + e[c].split(";")[0]));
          return document.cookie = n + "=" + i + f;
        }
      }
      function u(n, i) {
        if (!(typeof document > "u")) {
          for (var e = {}, g = document.cookie ? document.cookie.split("; ") : [], f = 0; f < g.length; f++) {
            var c = g[f].split("="), t = c.slice(1).join("=");
            !i && t.charAt(0) === '"' && (t = t.slice(1, -1));
            try {
              var C = d(c[0]);
              if (t = (r.read || r)(t, C) || d(t), i)
                try {
                  t = JSON.parse(t);
                } catch {
                }
              if (e[C] = t, n === C)
                break;
            } catch {
            }
          }
          return n ? e[n] : e;
        }
      }
      return o.set = s, o.get = function(n) {
        return u(
          n,
          !1
          /* read as raw */
        );
      }, o.getJSON = function(n) {
        return u(
          n,
          !0
          /* read as json */
        );
      }, o.remove = function(n, i) {
        s(n, "", p(i, {
          expires: -1
        }));
      }, o.defaults = {}, o.withConverter = a, o;
    }
    return a(function() {
    });
  });
})(x);
var w = x.exports;
const D = /* @__PURE__ */ v(w);
export {
  D as j
};
//# sourceMappingURL=js.cookie-Cz6eSHLt.mjs.map
